import { Button, Dialog, GenericSuspense, MainLogo, useTranslations } from "@mzara/component"
import { Link, Outlet, useNavigate, useParams } from "react-router-dom"
import { useAppointmentBoardInvitationsQuery } from "../hooks/useAppointmentBoardInvitationsQuery"
import { KanbanInvitationItem } from "../components/KanbanInvitationItem"
import { useCallback, useState } from "react"
import { useAppointmentBoardInvitationDeleteMutation } from "../hooks/useAppointmentBoardInvitationDeleteMutation"
import Mustache from 'mustache'

export const ProjectKanbanDetailsInvitationContainer = () => {

    const [
        ADD,
        CONFIRMATION,
        CONFIRM_MESSAGE,
        CONFIRM,
        CANCEL,
    ] = useTranslations(i18n)
    const { id } = useParams()
    const { data, invalidateQuery } = useAppointmentBoardInvitationsQuery(parseInt(id), true)
    const navigate = useNavigate()
    const [invitationId, setInvitationId] = useState<number>();
    const deleteMutation = useAppointmentBoardInvitationDeleteMutation();
    const handleDelete = useCallback(() => {
        deleteMutation.mutate(
            {
                ids: [invitationId],
            },
            {
                onSuccess: () => {
                    invalidateQuery();
                    setInvitationId(undefined);
                },
            }
        );
    }, [invitationId])

    return (
        <div className="flex flex-col gap-4">
            <div className="flex justify-end">
                <Link to={"create"}>
                    <Button className="btn-default" startIcon="fa-plus" label={ADD} />
                </Link>
            </div>
            <div className="flex flex-col gap-4">
                <KanbanInvitationItem
                    user={data.userCreator}
                    actions={"OWNER" as any}
                    createdAt={data.createdAt}
                />
                {
                    data?.invitations?.map((item) => (
                        <KanbanInvitationItem
                            key={item.id}
                            {...item}
                            isEditable={data.isEditable as any}
                            onEditClick={() => navigate(`edit/${item.id}`)}
                            onDeleteClick={() => setInvitationId(item.id)}
                        />
                    ))
                }
            </div>

            <GenericSuspense fallback={<MainLogo />}>
                <Outlet />
            </GenericSuspense>

            <Dialog
                open={invitationId !== undefined}
                title={CONFIRMATION}
                confirmation
                message={Mustache.render(
                    CONFIRM_MESSAGE, 
                    { 
                        userFullName: data?.invitations.find((item) => item.id === invitationId)?.user?.fullName
                    }
                )}
                btnCancel={{
                    label: CANCEL,
                    startIcon: "",
                }}
                btnOk={{
                    className: "btn-danger",
                    label: CONFIRM,
                    endIcon: "",
                    isSubmit: deleteMutation.isLoading
                }}
                onClose={() => setInvitationId(undefined)}
                onCancel={() => setInvitationId(undefined)}
                onConfirm={handleDelete}
            />
        </div>
    )
}

const i18n = [
    'std_add',
    "std_confirmation",
    "Harea.Project.Kanban.Invitation.Delete.Confirm.Message",
    "std_confirm",
    "std_cancel",

]
